import { getAuthSession } from "@benefit-systems/webview/plugins/auth";

import type { IStoredToken } from "web/types/Token";

import decodeTokenExpiry from "./decodeTokenExpiry";
import persistToken from "./persistToken";

let mobileTokenPromise: ReturnType<typeof getAuthSession> | null = null;

const getTokenNative = async (): Promise<IStoredToken | null> => {
  try {
    const response = await (mobileTokenPromise ??= getAuthSession());

    if (!response) {
      return null;
    }

    const { accessToken, idToken = "" } = response;
    const { exp, ttl } = decodeTokenExpiry(accessToken);
    const storedToken: IStoredToken = {
      token: accessToken,
      accessToken,
      idToken,
      exp,
      ttl,
    };

    persistToken(storedToken);

    return storedToken;
  } finally {
    mobileTokenPromise = null;
  }
};

export default getTokenNative;
